import { useAutocompleteSource } from '@eas/common-web';
import { UFormGovAgendaAutocomplete } from '../../models';
import { EvidenceAPI } from '../../enums';

export function useUFormGovAgendaAutocomplete() {
  return useAutocompleteSource<UFormGovAgendaAutocomplete>({
    url: `${EvidenceAPI.UFORM_GOV_AGENDA}/autocomplete`,
  });
}
